import { render, staticRenderFns } from "./dialogPolicyDetail.vue?vue&type=template&id=66129d68&scoped=true"
import script from "./dialogPolicyDetail.vue?vue&type=script&lang=js"
export * from "./dialogPolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogPolicyDetail.vue?vue&type=style&index=0&id=66129d68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66129d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66129d68')) {
      api.createRecord('66129d68', component.options)
    } else {
      api.reload('66129d68', component.options)
    }
    module.hot.accept("./dialogPolicyDetail.vue?vue&type=template&id=66129d68&scoped=true", function () {
      api.rerender('66129d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/dialogPolicyDetail.vue"
export default component.exports